module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","title":"Let me out","subTitle":"Are you sure you want logout?","logout":"Logout"},"ar":{"cancel":"الغاء"}}')
  delete Component.options._Ctor
}
